import qs from 'qs';
import axios from 'axios';
import { getUrlParam } from '@utils/url';
import { REVERSE_API_STATUS_MAP } from '@data/apiStatusMap';
import toast from '@components/toast';
import { sendError } from '@utils/cheka';

let userId = getUrlParam('user_id');
const TRACE_ID_HEADER = 'x-ragnar-traceid';
const defaultConfigs = {
  timeout: 10000,
  paramsSerializer: function (params) {
    return qs.stringify(params);
  },
  headers: {
    post: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  },
  transformRequest: [
    function (data) {
      return qs.stringify(data);
    },
  ],
};

const showError = function (msg, traceId) {
  let errorMsg = '';
  if (traceId) {
    errorMsg = 'Trace ID: ' + traceId;
  }
  toast({
    content: errorMsg || msg,
    type: 'error'
  });
};

const getTraceId = function (error) {
  let traceId = '';
  let headers = {};
  if (error.response && error.response.headers) {
    headers = error.response.headers;
  } else if (error.headers) {
    headers = error.headers;
  }
  for (const header in headers) {
    if (headers[header] && header.toLowerCase() === TRACE_ID_HEADER) {
      traceId = headers[header];
      break;
    }
  }
  if (!traceId && error.data) {
    traceId = error.data['trace_id'] || error.data['request_id'];
  }
  return traceId;
};

const successInterceptor = function (response, silent) {
  if (response && response.data && response.data.code == REVERSE_API_STATUS_MAP.SUCCESS) {
    return response.data;
  }

  const traceId = getTraceId(response);
  let errorMsg = '';
  if (!silent) {
    if (response && response.data && response.data.error) {
      errorMsg = response.data.error;
    } else if (response && response.data && response.data.message) {
      errorMsg = response.data.message;
    } else {
      errorMsg = '接口错误，请重试';
    }
    showError(errorMsg, traceId);
  }
  sendApiError(response, errorMsg);
  return Promise.reject(response);
};

const errorInterceptor = function (error, silent) {
  if (axios.isCancel(error) && error.message === 'CANCELED_DUE_TO_NEW_REQUEST') {
    return Promise.reject(error);
  }
  const traceId = getTraceId(error);
  let errorMsg = '';
  if (!silent) {
    if (error.response && error.response.status === 500) {
      errorMsg = '系统超时，请重试';
    } else if (error.code === 'ECONNABORTED' || (error.response && error.response.status === 408)) {
      errorMsg = '连接失败，请检查您的网络状况';
    } else {
      errorMsg = '网络超时，请重试';
    }
    showError(errorMsg, traceId);
  }
  sendApiError(error);
  return Promise.reject(error);
};

const factory = function (baseUrl, configs, silent, noInterceptor) {
  const mergedConfigs = Object.assign({}, defaultConfigs, configs || {});
  if (baseUrl) {
    mergedConfigs.baseURL = baseUrl;
  }
  if (!mergedConfigs.params) {
    mergedConfigs.params = {};
  }

  const instance = axios.create(mergedConfigs);
  if (noInterceptor) {
    return instance;
  }
  instance.interceptors.request.use(
    config => {
      if (typeof config.params['user_id'] === 'undefined' && userId) {
        config.params['user_id'] = userId;
      }
      return config;
    },
    error => {
      return Promise.reject(error);
    }
  );
  instance.interceptors.response.use(
    response => successInterceptor(response, silent),
    error => errorInterceptor(error, silent)
  );
  return instance;
};

const sendApiError = function (error, message = '') {
  let url = '';
  const traceId = getTraceId(error);
  const err = new Error(traceId);

  if (error.config) {
    url = error.config.url;
    err['api_method'] = error.config.method;
    err['api_payload'] = error.config.data;
  }
  err['name'] = url;
  err['type'] = 'api';
  err['api_trace_id'] = traceId;
  err['error_message'] = (error.data && error.data['message']) || message;
  if (error.data) {
    err['api_code'] = error.data.code;
  }
  if (error.response) {
    err['api_status'] = error.response.status;
  }
  sendError(err);
};

let baseApi = null;
let engineApi = null;
let silentApi = null;
export default {
  factory: factory,
  CancelToken: axios.CancelToken,
  isCancel: axios.isCancel,
  base() {
    if (!baseApi) {
      baseApi = factory(process.env.VUE_APP_API, {
        withCredentials: true,
      });
    }
    return baseApi;
  },
  engine() {
    if (!engineApi) {
      engineApi = factory(process.env.VUE_APP_ENGINE_API, {
        withCredentials: true,
      });
    }
    return engineApi;
  },
  baseSilent() {
    if (!silentApi) {
      silentApi = factory(process.env.VUE_APP_API, {
        withCredentials: true,
      }, true, true);
    }
    return silentApi;
  },
};
